import React, {useEffect, useState} from 'react';
import {PcEmail} from './pc/PcEmail'; // 注意这里是默认导入
import {MobileEmail} from './mobile/MobileEmail';
import {isValidEmail} from "../../../../utils/common";
import {openEmail} from "../../../../tracking/external"; // 注意这里是默认导入

function Email({isMobile, clicked, clickNext, setAllow, isCurPage, value, ...props}) { // 接收 isMobile props
    const [email, setEmail] = useState(value);
    useEffect(() => {
        setAllow(isValidEmail(email));
    }, [email]);

    useEffect(() => {
        if (isCurPage) {
            openEmail();
        }

    }, [isCurPage])

    useEffect(() => {
        if (clicked) {
            clickNext(email)
        }
    }, [clicked]);

    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clicked,
        setEmail,
        email,
        isCurPage,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };

    if (isMobile) { // 根据 isMobile props 条件渲染
        return <MobileEmail {...commonProps} />;
    } else {
        return <PcEmail {...commonProps} />;
    }
}

export default Email;